var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.461,
    height: 17.968,
    viewBox: "0 0 22.461 17.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(-320.769 -854.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gcp-svgrepo-com",
    transform: "translate(320.27 852.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M14.3,7.055l2.826-2.246-.5-.62A8.81,8.81,0,0,0,2.3,8.482c-.045.169.467-.147.693-.084L6.9,7.757s.19-.186.3-.307a4.919,4.919,0,0,1,6.686-.53l.407.135Z",
    transform: "translate(0.896 0)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M16.616,7.712a8.737,8.737,0,0,0-2.65-4.25l-2.74,2.725a4.831,4.831,0,0,1,1.786,3.839v.484a2.425,2.425,0,1,1,0,4.85l-4.877,0-.487.052v3.754l.487.079h4.877a6.3,6.3,0,0,0,3.6-11.53Z",
    transform: "translate(3.555 0.727)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M5.983,15.369h4.88V11.485H5.982a2.477,2.477,0,0,1-1.006-.241l-.686.21L2.324,13.4l-.171.669a6.37,6.37,0,0,0,3.829,1.3Z",
    transform: "translate(0.822 4.598)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M6.805,5.572A6.306,6.306,0,0,0,2.977,16.886l2.83-2.821a2.429,2.429,0,1,1,3.225-3.209l2.83-2.812A6.349,6.349,0,0,0,6.8,5.572Z",
    transform: "translate(0 1.776)",
    fill: "#fbbc05"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/gcp.921654a49214ee02d219cfc0f5cbbe65.svg";
export { ForwardRef as ReactComponent };